// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { AppBar, Box, Divider, Toolbar } from '@mui/material';
import ErrorWrapper from '../components/ErrorWrapper';
import { HeaderContent } from '../components/Header/HeaderContent';
import { ModulesPopoverMenu } from '../components/Header/ModulesPopoverMenu';
import SpliceWalletControls from '../components/SpliceWalletControls';
import { TabNavigation } from '../components/TabNavigation';
import { useBranding } from '../contexts/BrandingContext';
import { useIsSmall } from '../hooks/other/useIsSmall';

export const Header: React.FC = () => {
  const { branding } = useBranding();
  const isSmall = useIsSmall();
  const nav = useNavigate();
  const onLogoClick = () => {
    nav('/');
  };
  return (
    <ErrorWrapper>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
        <AppBar elevation={0} sx={{ display: 'flex', flexDirection: 'column' }} position="fixed">
          <Toolbar
            sx={{
              alignItems: 'center',
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Box sx={{ cursor: 'pointer' }} onClick={onLogoClick}>
              {branding.headerLogo}
            </Box>
            <ModulesPopoverMenu />
            <SpliceWalletControls />
            <HeaderContent />
          </Toolbar>
          {isSmall && <TabNavigation />}
          <Divider />
        </AppBar>

        <Box sx={{ marginTop: 8, height: '100%', overflow: 'auto' }}>
          <Outlet />
        </Box>
      </Box>
    </ErrorWrapper>
  );
};
